import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { DateCheckValidator } from 'src/app/pages/user/user.util';
import * as moment from 'moment';
import { PackagesService } from '../../packages.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-package-schedule-creation',
  templateUrl: './package-schedule-creation.component.html',
  styleUrls: ['./package-schedule-creation.component.css']
})
export class PackageScheduleCreationComponent implements OnInit {

  @Input() packageForm: DVFormGroup;

  settings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
  };

  weekdays = moment.weekdays().map((v, i) => ({id: i + 1, name: v }));

  // scheduleTypes = [];
  selectedItemsID = [];

  constructor(
    private packageApi: PackagesService
  ) {
  }

  ngOnInit() {
    // this.packageForm.addDynamicAsyncValidator(new DateCheckValidator(['startDate', 'endDate'], 'Start Date should be after end date'));
    // this.packageApi.getAllPackageTypes().subscribe(response => {
    //   this.scheduleTypes = response.data.packageTypes;

    // });
    // this.packageForm.controls.packageTypes.valueChanges.subscribe(newValue => {
    //   this.updateSelectedIds(newValue);
    // });
  }

  updateSelectedIds(selected) {
    this.selectedItemsID = selected.map(t => t.id);
  }

}
